import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Field} from 'redux-form';
import {Link} from 'react-router-dom';

import {
  DeliveryAddressLabel,
  DeliveryFeeMessage,
  Error,
  FieldDiv,
  FieldRow,
  Label
} from './CheckoutPage.style';

import {
  validateMinimumLength,
  validateRequired
} from '../../helpers/formValidation.helper';
import Price from '../../components/Price/Price';
import {RenderTextInput} from '../../components/ReduxForm/RenderTextInput';

const DeliveryAddress = ({
    basketMessages,
    basketPrice,
    dataInitializedFromStorage,
    deliverySettings,
    setServiceTypeCollection,
    showCheckoutDeliveryFee,
    showDeliveryMinimumAmountError
  }) => {
  const deliveryErrors =
    basketMessages &&
    basketMessages.length > 0 &&
    basketMessages.map(
      message =>
        message.code !== 'delivery_minimum' && (
          <Error key={message.code}>
            {message.code === 'delivery_out_of_range' ? (
              <FormattedMessage
                id="checkout.deliveryErrorOutOfRange"
                values={{
                  link: (
                    <a
                      href="#"
                      onClick={setServiceTypeCollection}
                    >
                      <FormattedMessage id="checkout.clickHere" />
                    </a>
                  )
                }}
              />
            ) : (
              message.text
            )}
          </Error>
        )
    );

  const deliveryFeeError = showCheckoutDeliveryFee && (
    <DeliveryFeeMessage>
      <FormattedMessage
        id="checkout.deliveryFee"
        values={{
          price: <Price amount={basketPrice.delivery} />
        }}
      />
    </DeliveryFeeMessage>
  );

  const deliveryMinimumAmountError = showDeliveryMinimumAmountError && (
    <Error>
      <FormattedMessage
        id="checkout.deliveryMinimumAmountErrorLine1"
        values={{
          price: <Price amount={deliverySettings.minimumAmount - basketPrice.total} />,
          minimumAmount: <Price amount={deliverySettings.minimumAmount} />
        }}
      />
      <br />
      <FormattedMessage
        id="checkout.deliveryMinimumAmountErrorLine2"
        values={{
          link: (
            <Link to="/menu">
              <FormattedMessage id="checkout.pleaseClickHere" />
            </Link>
          )
        }}
      />
    </Error>
  );

  return (
    <div>
      <Label>
        <FormattedMessage id="checkout.deliveryAddress" />
      </Label>
      <FieldRow id="deliveryAddress">
        <FieldDiv nomargin>
          <DeliveryAddressLabel for="addressLine1">
            <FormattedMessage id="checkout.deliveryAddressLine1" />
            <Field
              id="addressLine1"
              name="addressLine1"
              type="text"
              maxLength="180"
              component={RenderTextInput}
              validate={[validateRequired, validateMinimumLength]}
              dataInitializedFromStorage={dataInitializedFromStorage}
            />
          </DeliveryAddressLabel>
        </FieldDiv>
      </FieldRow>
      <FieldRow>
        <FieldDiv>
          <DeliveryAddressLabel for="city">
            <FormattedMessage id="checkout.deliveryAddressCity" />
            <Field
              id="city"
              name="city"
              type="text"
              maxLength="100"
              component={RenderTextInput}
              validate={[validateRequired]}
              dataInitializedFromStorage={dataInitializedFromStorage}
            />
          </DeliveryAddressLabel>
        </FieldDiv>
        <FieldDiv nomargin>
          <DeliveryAddressLabel for="postcode">
            <FormattedMessage id="checkout.deliveryAddressPostcode" />
            <Field
              id="postcode"
              name="postcode"
              type="text"
              maxLength="35"
              component={RenderTextInput}
              validate={[validateRequired]}
              dataInitializedFromStorage={dataInitializedFromStorage}
            />
          </DeliveryAddressLabel>
        </FieldDiv>
      </FieldRow>
      {deliveryErrors}
      {deliveryMinimumAmountError}
      {deliveryFeeError}
    </div>
  );
};

DeliveryAddress.propTypes = {
  basketMessages: PropTypes.array.isRequired,
  basketPrice: PropTypes.object.isRequired,
  dataInitializedFromStorage: PropTypes.bool.isRequired,
  deliverySettings: PropTypes.object.isRequired,
  setServiceTypeCollection: PropTypes.func.isRequired,
  showCheckoutDeliveryFee: PropTypes.bool.isRequired,
  showDeliveryMinimumAmountError: PropTypes.bool.isRequired
};

export default DeliveryAddress;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/DeliveryAddress.js